import { dm_tinhtrang_honnhan } from '../models/response/category/dm_tinhtrang_honnhan';
import { apiClient } from './apiClient';
import { apiGuestClient } from './apiGuestClient';

export const TINH_TRANG_HON_NHAN_API_END_POINT = "tinh-trang-hon-nhan";

export const tinhTrangHonNhanApi = {
    // Lấy tất cả tình trạng hôn nhân
    selectAll: () => apiGuestClient.get(`${TINH_TRANG_HON_NHAN_API_END_POINT}`),

    // Lấy chi tiết tình trạng hôn nhân theo ID
    detail: (id: number) => apiClient.get(`${TINH_TRANG_HON_NHAN_API_END_POINT}/${id}`),

    // Thêm mới tình trạng hôn nhân
    insert: (data: dm_tinhtrang_honnhan) => apiClient.post(`${TINH_TRANG_HON_NHAN_API_END_POINT}`, data),

    // Cập nhật tình trạng hôn nhân
    update: (data: dm_tinhtrang_honnhan) => apiClient.put(`${TINH_TRANG_HON_NHAN_API_END_POINT}`, data),

    // Xóa tình trạng hôn nhân
    delete: (id: number) => apiClient.delete(`${TINH_TRANG_HON_NHAN_API_END_POINT}/${id}`),
};
